import { IconEye, IconX } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../session';
import { toast } from '../toast';
import classes from './shell.module.css';

/** "Viewing as <name> — read only — Exit": shown on every page while View as is on (D10). */
export function ViewAsBanner() {
  const { viewingAs, exitViewAs } = useSession();
  const navigate = useNavigate();
  const [leaving, setLeaving] = useState(false);
  if (!viewingAs) return null;

  const exit = async () => {
    setLeaving(true);
    try {
      await exitViewAs();
      navigate(`/people/${viewingAs.personId}`);
    } catch (err) {
      toast.error("Couldn't exit View as", err instanceof Error ? err.message : undefined);
      setLeaving(false);
    }
  };

  return (
    <div className={classes.viewAs} role="status" aria-live="polite">
      <IconEye size={18} stroke={2} aria-hidden="true" />
      <span className={classes.viewAsText}>
        <span>
          Viewing as <strong>{viewingAs.name}</strong>
        </span>
        <span className={classes.viewAsReadOnly}>Read only</span>
      </span>
      <button
        type="button"
        className={classes.viewAsExit}
        onClick={() => void exit()}
        disabled={leaving}
      >
        <IconX size={16} stroke={2} aria-hidden="true" />
        Exit
      </button>
    </div>
  );
}
